import { joinBoardByNamespace } from '@/services/import-api.service'
import { logger } from '@/utils/logger'

export async function getDayforceNamespace(user) {
  if (!user?.getIdTokenResult) return ''

  const tokenResult = await user.getIdTokenResult(false)
  const namespace = tokenResult?.claims?.namespace || tokenResult?.claims?.dayforceNamespace || ''
  if (namespace) {
    return namespace
  }

  // Fallback: force a refresh only if namespace was missing from the cached token result.
  const refreshedTokenResult = await user.getIdTokenResult(true)
  return (
    refreshedTokenResult?.claims?.namespace || refreshedTokenResult?.claims?.dayforceNamespace || ''
  )
}

export async function joinBoardForDayforceUser({ user, namespace = '' }) {
  if (!user) return { boardId: null, namespace: '' }

  const resolvedNamespace = namespace || (await getDayforceNamespace(user))
  if (!resolvedNamespace) {
    return { boardId: null, namespace: '' }
  }

  const joinResult = await joinBoardByNamespace({ namespace: resolvedNamespace })

  return {
    boardId: joinResult?.boardId || null,
    namespace: resolvedNamespace
  }
}

export async function ensureEmbeddedBoardsLoaded({ store, namespace = '' }) {
  const user = store?.getters?.user
  if (!user?.uid) return []

  let fetchedFreshBoards = false

  try {
    await store.dispatch('fetchAllBoards', user.uid)
    fetchedFreshBoards = true
  } catch (error) {
    logger.warn('[DayforceBoardResolution] Failed to fetch boards before namespace join:', error)
  }

  const fetchedBoards = store.getters.mainBoards || []
  if (fetchedFreshBoards && fetchedBoards.length > 0) {
    return fetchedBoards
  }

  try {
    const resolvedNamespace = namespace || (await getDayforceNamespace(user))
    const { boardId } = await joinBoardForDayforceUser({ user, namespace: resolvedNamespace })
    if (boardId) {
      try {
        await store.dispatch('fetchAllBoards', user.uid)
        fetchedFreshBoards = true
      } catch (error) {
        logger.warn(
          '[DayforceBoardResolution] Failed to refresh boards after namespace join:',
          error
        )
      }
    }
  } catch (error) {
    logger.warn('[DayforceBoardResolution] Failed to join board for embedded user:', error)
  }

  return fetchedFreshBoards ? store.getters.mainBoards || [] : []
}
